<style lang="stylus">
    .y-scroll-wrapper
        position: absolute; right: 0; top: 0; width: 10px; height: 253px; background-color: var(--bg--color-excel-table-scroll-wrapper)
    .x-scroll-wrapper
        position: absolute; left: 0; bottom: 0; width: 364px; height: 12px; background-color: var(--bg--color-excel-table-scroll-wrapper)
    .tbcontainer
        position relative
        width calc(100% - 10px)
        height calc(100% - 10px)
        overflow hidden
        .tb_excel
            position relative
            border-collapse separate
            border-spacing 0
            margin 0
            border-width 0
            table-layout fixed
            width 0
            outline-width 0
            max-width none
            max-height none
            user-select none
            tr,td,th
                padding 0
                margin 0
                outline 0
                border 0
            .hearCol
                width 50px
            thead
                height 22px
                box-sizing content-box
                tr
                    th
                        height 22px
                        padding 0 4px
                        background-color var(--bg-color-excel-table-th)
                        border-top 1px solid var(--border-color-excel-table)
                        border-right 1px solid var(--border-color-excel-table)
                        border-bottom 1px solid var(--border-color-excel-table)
                        color var(--text-color-excel-table-th)
                        text-align left
                        text-indent 10px
                        line-height 22px
                        font-size 14px
                        white-space nowrap
                        vertical-align top
                        overflow hidden
                        outline-width 0
                        white-space pre-line
                        &:first-child
                            border-left 1px solid var(--border-color-excel-table)
                    .XhightLight
                        background-color var(--bg--color-excel-table-hightlight)

            tbody
                tr
                    th
                        height 22px
                        padding 0 4px
                        background-color var(--bg-color-excel-table-th)
                        border-right 1px solid var(--border-color-excel-table)
                        border-bottom 1px solid var(--border-color-excel-table)
                        color var(--text-color-excel-table-th)
                        text-align left
                        text-indent 5px
                        line-height 22px
                        font-size 12px
                        white-space nowrap
                        vertical-align top
                        overflow hidden
                        outline-width 0
                        white-space pre-line
                        &:first-child
                            border-left 1px solid var(--border-color-excel-table)
                    .YhightLight
                        background-color var(--bg--color-excel-table-hightlight)
                    td
                        height 23px
                        padding 0 4px
                        background-color var(--bg-color-excel-table-td)
                        border-top 1px solid transparent
                        border-left 1px solid transparent
                        border-right 1px solid var(--border-color-excel-table)
                        border-bottom 1px solid var(--border-color-excel-table)
                        color var(--text-color-excel-table-td)
                        text-align center
                        line-height 21px
                        font-size 12px
                        white-space nowrap
                        overflow hidden
                        p
                            display block
                            padding 0
                            margin 0
                            overflow hidden
                            text-overflow ellipsis
                    .gray_td
                        background-color #eee
                    .area_td
                        background-color var(--bg--color-excel-table-area-id)
        .width_control
            position absolute
            top 0
            left 0
            width 100%
            height 24px
            z-index 99
            .width_shortline
                display block
                position absolute
                margin-left -3px
                width 5px
                height 22px
                cursor pointer

            .width_longline
                display none
                position absolute
                top 23px
                width 1px
                margin-left -1px
                background-color black
            .width_colorbtn
                position absolute
                top 7px
                width 15px
                height 10px
                background-color #000
                user-select none
                cursor pointer
            .width_shortline:hover
                background-color #666
        .left_control
            position absolute
            top 0
            left 0
            width 40px
            height 100%
            z-index 100
            .height_colorbtn
                position absolute
                left 30px
                width 15px
                height 10px
                background-color #000
                user-select none
                cursor pointer
        .current_box
            display none
            position absolute
            pointer-events none
            left 0
            right 0
            width 48px
            height 24px
            border 1px solid var(--border--color-excel-table-area-box)
            background-color var(--border--color-excel-table-current-box)
        .area_box
            display none
            position absolute
            pointer-events none
            left 0
            right 0
            width 48px
            height 22px
            border 1px solid var(--border--color-excel-table-area-box)
        .drag_box
            display none
            position absolute
            border 1px solid red
            pointer-events none
        .corner
            position absolute
            width 5px
            height 5px
            right 0
            bottom 0
            background-color var(--border--color-excel-table-area-corner)
            cursor crosshair
            pointer-events all
        .input_box
            display none
            position absolute
            left 0
            right 0
            width 48px
            height 24px
            margin-top 0
            background-color #fff
            input
                position absolute
                width 100%
                height 100%
                left 0
                top 0
                margin 0
                padding 0
                border 0
                text-align center
                background-color var(--bg--color-excel-table-input-box)
                outline var(--border--color-excel-table-area-box) solid 2px
</style>

<template>
    <div
        style="position: relative"
        :style="{ height: `${yscrollSize}px`, width: `${xscrollSize}px` }"
        @mouseleave="mouseLeave"
        @mouseenter="eventInit()"
        v-click-outside="cleanEditStatus"
    >
        <div id="tbContainer" class="tbcontainer">
            <table id="tbExcel" class="tb_excel" border="0" cellspacing="0" cellpadding="0">
                <colgroup>
                    <col class="hearCol" />
                    <col v-for="item in renderCol" :style="`width: ${item}px`" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div></div>
                        </th>
                        <th v-for="item in xArr" :class="{ XhightLight: XhightLight.includes(item) }">
                            <span>{{ setTHeadName(item) }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody ref="tbExcelBody">
                    <tr v-for="(item, yindex) in yArr">
                        <th :class="{ YhightLight: YhightLight.includes(item) }">{{ item }}</th>
                        <td
                            :class="{
                                gray_td: grayRule(xindex, yindex),
                                area_td: areaRule(xindex, yindex),
                            }"
                            v-for="(item, xindex) in xArr"
                        >
                            <p v-if="renderData[yindex]">{{ renderData[yindex][xindex] }}</p>
                            <p v-else></p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div id="topControl" class="width_control">
                <span id="WidthControlShortLine" class="width_shortline" :style="`left: 0px`"></span>
                <div id="WidthControlLongLine" class="width_longline" :style="`height:${yViewCount * baseHeight}px`"></div>
                <div
                    class="width_colorbtn"
                    v-show="index != 0 && (showColor == 1 || isEchartItem)"
                    v-for="(item, index) in colorHList"
                    v-if="index >= widthOffset"
                    :style="{ left: 90 + renderLine[index - widthOffset] + 'px', backgroundColor: item }"
                    @click.stop="showColorBox($event, index, item)"
                ></div>
            </div>
            <div id="leftControl" class="left_control">
                <div
                    class="height_colorbtn"
                    v-show="(showColor == 2 || isEchartItem) && 7 + baseHeight * (index + vLineOffsetNum - heightOffset) > baseHeight"
                    v-for="(item, index) in colorVList"
                    v-if="index >= heightOffset - vLineOffsetNum"
                    :style="{ top: 7 + baseHeight * (index + vLineOffsetNum - heightOffset) + 'px', backgroundColor: item || 'transparent' }"
                    @click.stop="showColorBox($event, index, item)"
                ></div>
            </div>
            <div id="currentBox" class="current_box">
                <div id="currentBox_corner" class="corner" v-show="!areaFlag" @mousedown="dragBox($event, 1)"></div>
            </div>
            <div id="areaBox" class="area_box">
                <div id="areaBox_corner" class="corner" v-show="areaFlag" @mousedown="dragBox($event, 2)"></div>
            </div>
            <div id="dragBox" class="drag_box"></div>
            <div id="inputBox" class="input_box">
                <input type="text" @blur="closeInputBox()" />
            </div>
        </div>

        <div class="y-scroll-wrapper">
            <Scroll
                ref="yscroller"
                :scrollSize="yscrollSize - 10"
                :scrollType="1"
                @yScroll="yScroll($event)"
                :sliderWidth="scrollBlockHeight"
            ></Scroll>
        </div>
        <div class="x-scroll-wrappper">
            <Scroll ref="xscroller" :scrollSize="xscrollSize" :scrollType="0" @xScroll="xScroll($event)" :sliderWidth="scrollBlockWidth"></Scroll>
        </div>

        <input id="chartExcelInput" accept=".xlsx,.csv" type="file" style="display: none" @change="importExcel($event)" />
        <ExcelContext
            v-show="showContext"
            :menuType="menuType"
            :position="contextPos"
            @closeEvent="closeContext"
            @handleContextEvent="handleContextEvent"
        />
    </div>
</template>

<script lang="ts">
    declare var eFlagExcelImport: any;
    declare var EDView: any;
    import { Component, Prop, Emit, Vue, Watch, Inject } from "vue-property-decorator";
    import Scroll from "./ExcelScroll.vue";
    import { chartData, ChartData } from "@/app/components/FloatTool/echart/chartData";
    import ExcelContext from "./ExcelContext.vue";
    import { fixThousandSeparatedNumber } from "@/public/utils/tool.js";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Scroll,
            ExcelContext,
        },
    })
    export default class ExcelTable extends Vue {
        @Prop()
        chartData: Array<Array<string>>;
        @Prop()
        chartType: string;
        @Inject()
        ["showMessage"];

        firstFlag: boolean = true;
        baseHeight: number = 23; // 一行tr的高度，修复1.x倍dpi显示错误
        scrollBlockHeight: number = 0; // y轴滑块大小
        scrollBlockWidth: number = 0; // x轴滑块大小

        areaFlag: boolean = false; // 是否区域选择
        widthControlFlag: boolean = false; // 宽度控制节流
        inputFlag: boolean = false; // 输入框
        keyFlag: boolean = false; // 键盘
        leftClickAll: boolean = false; // 点击左边全选行
        topClickAll: boolean = false; // 点击上边全选列
        startDrag: boolean = false; // 开始拖拽选择
        DragScroll: number = 0; // 拖拽选择情景下滚动的次数
        XDragScroll = 0;
        startShift: boolean = false; // shift选择情景下滚动的次数
        shiftScroll: number = 0; // shift选择情景下滚动的次数
        tempInputValue: string = ""; // input值 用于判断是否修改
        tempPosition: Array<number> = [0, 0]; // click 坐标

        xEnd: number = 3; // 初始视野外可视横轴个数。跟宽度有一定联系  (xEnd + xViewCount) * 60 + 50 > xscrollSize
        yEnd: number = 20; // 初始视野外可纵横轴个数。跟高度有一定联系  (yViewCount - 1) * 23 > yscrollSize
        xViewCount: number = 4; // 初始视野内可视横轴个数
        yViewCount: number = 18; // 初始视野内可视纵轴个数
        xscrollSize: number = 360 + 10; // 表格初始宽度。 改动需调整ui style
        // yscrollSize: number = 506 + 10; // 表格初始高度，改用computed
        widthOffset: number = 0;
        heightOffset: number = 0;
        colWidthIndex: number = 0;
        XcurrentIndex: number = 0;
        YcurrentIndex: number = 0;
        YScrollOffset: number = 0;
        selectArea: Array<number> = []; // xstart, xend, ystart, yend   for ui
        selectDataArea: Array<number> = []; // xstart, xend, ystart, yend   for data
        outOfView: boolean = false; // 选择区域有部分在视野外
        outOfViewDrag: boolean = false; // 拖拽选择区域有部分在视野外
        outOfViewShift: boolean = false; // shift选择区域有部分在视野外
        xArr: Array<number> = [1, 2, 3, 4, 5, 6, 7];
        yArr: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
        XhightLight: Array<number> = []; // 高亮x轴
        YhightLight: Array<number> = []; // 高亮y轴
        XAreaCell: Array<number> = [];
        YAreaCell: Array<number> = [];
        basedata: Array<Array<string>> = [
            ["  ", "g", "y", "z", "k", "!"],
            ["光", "0", "0", "0", "0", "0"],
            ["翼", "1", "1", "1", "1", "1"],
            ["展", "2", "2", "2", "2", "2"],
            ["开", "3", "3", "3", "3", "3"],
            ["！", "4", "4", "4", "4", "4"],
        ];
        importExcelData: Array<Array<string>> = []; // excel 导入的数据
        baseCol: Array<number> = [80, 80, 80, 80, 80, 80, 80];
        renderData: Array<Array<string>> = [];
        renderCol: Array<number> = []; // 控制每一列的宽度
        renderLine: Array<number> = [0, 80, 160, 210, 260, 310, 360, 410, 460, 510];
        copyEL: any;
        pasteEL: any;
        cutEL: any;
        /**table */
        regularColumnRow: Array<number>; // 不规则表初始行列
        regularMap: Array<Array<string>>;
        /**Color */
        showColor: number = 0;
        colorH: Array<string> = []; // 水平颜色
        colorV: Array<string> = []; // 垂直颜色

        get isEchartItem() {
            return this.shapeType == "EChartItem";
        }
        get yscrollSize() {
            // 表格初始高度
            if (this.isEchartItem) {
                return 483 + 10;
            } else {
                return 506 + 10;
            }
        }
        get colorHList() {
            if (this.isEchartItem) {
                return this.echartHColorList;
            } else {
                return this.colorH;
            }
        }
        get colorVList() {
            if (this.isEchartItem) {
                return this.echartVColorList;
            } else {
                return this.colorV;
            }
        }

        get vLineOffsetNum() {
            // 垂直方向行偏移
            if (this.isEchartItem) {
                return 1;
            } else {
                return 2;
            }
        }

        // methods
        setTHeadName(item) {
            // 返回 A AA AAA
            let temp = item,
                percentile = 0,
                tenth = 0;
            while (temp > 18278) {
                // 超出zzz
                alert("数据过大");
                return;
            }
            while (temp > 702) {
                temp -= 676;
                percentile++;
            }
            while (temp > 26) {
                temp -= 26;
                tenth++;
            }
            if (percentile != 0) {
                return String.fromCharCode(percentile + 64) + String.fromCharCode(tenth + 64) + String.fromCharCode(temp + 64);
            } else if (tenth != 0) {
                return String.fromCharCode(tenth + 64) + String.fromCharCode(temp + 64);
            } else {
                return String.fromCharCode(item + 64);
            }
        }
        grayRule(x, y) {
            // 灰色底色规则
            return false;
            // return (y == 0 && x != 0 && !(this.heightOffset != 0)) ||
            // (x == 0 && y != 0 && !(this.widthOffset != 0)) ||
            // (x == 0 && y == 0 && this.heightOffset != 0) ||
            // (x == 0 && y == 0 && this.widthOffset != 0)
        }
        areaRule(x, y) {
            // 区域选中规则
            return this.XAreaCell.includes(x) && this.YAreaCell.includes(y);
        }
        setScrollerSize(type, num) {
            // type 0 为横轴，1为纵轴
            num = num < 1 ? 1 : num;
            let xMax = this.xscrollSize - 22,
                yMax = this.yscrollSize - 22,
                min = 15,
                length = (!!type && (2 * yMax) / (15 * num)) || (2 * xMax) / (15 * num);
            if (!!type) {
                length = length > yMax ? yMax : length < min ? min : length;
            } else {
                length = length > xMax ? xMax : length < min ? min : length;
            }
            return length;
        }
        resetScroller() {
            this.YScrollOffset = 0;
            this.widthOffset = 0;
            this.heightOffset = 0;
            this.$nextTick(() => {
                (this.$refs["xscroller"] as any).changeSliderSize(0, 0);
                (this.$refs["yscroller"] as any).changeSliderSize(1, 0);
            });
        }
        eventInit() {
            this.$store.commit("toShow", {
                type: "editEChart",
                data: true,
            });
            let tControl = document.getElementById("topControl");
            let lControl = document.getElementById("leftControl");
            let table = document.getElementById("tbExcel");
            let shortline = document.getElementById("WidthControlShortLine");

            tControl.onmousemove = (e) => this.widthControl(e); // 控制短线显示隐藏
            tControl.onclick = (e) => this.topClick(e); // 点击顶部全选
            tControl.oncontextmenu = (e) => this.handleContext(e, 0);
            lControl.onclick = (e) => this.leftClick(e); // 点击左边全选
            lControl.oncontextmenu = (e) => this.handleContext(e, 1);
            shortline.onmousedown = (e) => this.shortlineClick(e); // 拖拽短线
            shortline.onclick = (e) => {
                e.stopPropagation();
            }; // 阻止父元素事件
            table.onmousedown = (e) => this.dragCell(e); // 拖拽单元格
            table.ondblclick = (e) => this.showInputBox(e); // 双击显示inputbox
            table.onwheel = (e) => this.tableWheel(e); // 滚动鼠标事件
            document.addEventListener("keydown", this.keyboardEvent); // 键盘事件

            document.addEventListener("copy", this.copyEL);
            document.addEventListener("paste", this.pasteEL);
            document.addEventListener("cut", this.cutEL);
        }
        dataInit(data) {
            // 初始化表格数据
            this.regularMap = [];
            for (let i = 0; i < data.length; i++) {
                this.regularMap.push([]);
                for (let j = 0; j < data[i].length; j++) {
                    if (data[i][j] != undefined) {
                        this.regularMap[i][j] = "";
                    }
                }
            }
            this.basedata = data;
            if (this.firstFlag) {
                this.firstFlag = false;
                this.resetScroller();
                this.xEnd = 3;
                this.yEnd = 20;
                this.xArr.splice(0, this.xArr.length, ...[1, 2, 3, 4, 5, 6, 7]);
                this.baseCol = Array.from({ length: 7 }, (v, i) => (i == 0 ? 80 : 80)); // 恢复初始设置
                this.yViewCount = Math.floor(this.yscrollSize / this.baseHeight) - 1; // 设置初始视野内可视纵轴个数
                this.yArr = Array.from({ length: this.yViewCount }, (v, k) => k + 1); // 填充值

                let xLength = this.basedata[0].length < 7 ? 7 : this.basedata[0].length + this.xEnd;
                while (this.basedata.length > this.yViewCount + this.yEnd) {
                    // 初始数据大于 (视图可视高度 + 高度极限值) 增加行
                    this.addRow();
                }
                while (xLength >= this.xViewCount + this.xEnd) {
                    this.addColumn();
                }
                this.scrollBlockHeight = this.setScrollerSize(1, this.yEnd);
                this.scrollBlockWidth = this.setScrollerSize(0, this.baseCol.length - 1 - this.xViewCount - this.xEnd);
            }
            this.setRenderData();
        }
        getStyle(dom, attr) {
            return dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom)[attr];
        }
        getIndex(target) {
            // 获取当前选中单元格坐标
            let xparent = target.parentNode;
            let yparent = xparent.parentNode;
            let xindex, yindex;
            for (let i = 0; i < xparent.children.length; i++) {
                if (target == xparent.children[i]) {
                    xindex = i - 1;
                }
            }
            for (let j = 0; j < yparent.children.length; j++) {
                if (xparent == yparent.children[j]) {
                    yindex = j;
                }
            }
            return { xindex, yindex };
        }
        clearHight() {
            // 清除区域高亮
            this.closeAreaBox();
            this.YhightLight = [];
            this.XhightLight = [];
            this.XAreaCell = [];
            this.YAreaCell = [];
        }
        selectCell(xindex, yindex) {
            // 选中单元格高亮
            this.tempPosition = [xindex, yindex];
            this.selectDataArea = [xindex, xindex, yindex, yindex];
            this.XcurrentIndex = xindex;
            let current = document.getElementById("currentBox");
            if (current) {
                current.style.display = "block";
                current.style.left = `${this.renderLine[this.XcurrentIndex] + 49}px`;
                current.style.width = `${this.renderCol[this.XcurrentIndex] + 1}px`;
                current.style.top = `${(yindex + 1) * this.baseHeight}px`;
            }
            let inputbox = document.getElementById("inputBox");
            if (inputbox && inputbox.childElementCount) {
                let input = <HTMLInputElement>inputbox.children[0];
                let left = 48 + this.renderLine[xindex];
                let top = (yindex + 1) * this.baseHeight;
                let width = this.renderCol[xindex] + 2;
                if (xindex == 0) {
                    left = 48;
                }
                inputbox.style.cssText = `left:${left}px;top:${top}px;width:${width}px;display:block;opacity:0;z-index:-1;`;
                input.focus({ preventScroll: true });
            }
        }
        clearSelectCell() {
            // 清除选择单元格
            let current = document.getElementById("currentBox");
            current && (current.style.display = "none");
        }
        shiftSelect(x, y) {
            this.startShift = false;
            let basePosition = this.tempPosition;
            let XArr = [],
                YArr = [];
            let XEnd, YEnd, XStart, YStart;
            if (basePosition[0] > x) {
                XEnd = basePosition[0];
                XStart = x;
            } else {
                XEnd = x;
                XStart = basePosition[0];
            }
            if (basePosition[1] > y) {
                YEnd = basePosition[1];
                YStart = y;
            } else {
                YEnd = y;
                YStart = basePosition[1];
            }
            if (this.shiftScroll > 0) {
                // 下滚
                if (YStart - this.shiftScroll < 0) {
                    this.outOfViewShift = true;
                }
                YStart -= this.shiftScroll;
            } else {
                if (YEnd + this.shiftScroll < 0) {
                    this.outOfViewShift = true;
                }
                YEnd -= this.shiftScroll;
            }
            for (let i = XStart; i <= XEnd; ++i) {
                XArr.push(i);
            }
            for (let i = YStart; i <= YEnd; ++i) {
                YArr.push(i);
            }
            this.XhightLight = XArr.map((v) => v + 1 + this.widthOffset);
            this.XAreaCell = XArr;
            this.YhightLight = YArr.map((v) => v + 1 + this.heightOffset);
            this.YAreaCell = YArr;
            this.showAreaBox();
        }
        getTotalRowLine() {
            let row = 0,
                line = 0;
            for (let i = 0; i < this.basedata.length; i++) {
                row = i + 1;
                if (this.basedata[i]) {
                    let length = this.basedata[i].length;
                    line = line > length ? line : length;
                }
            }
            return { row, line };
        }
        hexify(color) {
            // rgba => #ffffff
            if (/^#/.test(color) || color == "") return color;
            var values = color
                .replace(/rgba?\(/, "")
                .replace(/\)/, "")
                .replace(/[\s+]/g, "")
                .split(",");
            var a = parseFloat(values[3] || 1),
                r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
                g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
                b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
            return "#" + ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
        }
        get colorIndex() {
            return this.$store.state.echart.colorIndex;
        }
        set colorIndex(v) {
            this.$store.commit("setEChartState", {
                type: "colorIndex",
                data: v,
            });
        }
        showColorBox(e, id, color) {
            if (color === "") return;
            const option = JSON.parse(this.echartOption);
            this.colorIndex = id;
            let node = e.target;
            let payload = {
                type: this.fmtType.echart,
                index: id,
            };
            this.$store.commit("setEChartState", {
                type: "activeSeriesColor",
                data: color,
            });
            this.$store.commit("setColor", payload);

            let type = "123";
            const isEdEchartScatter01 = option.edEchartLabel === "scatter01";
            const isEdEchartBar09 = option.edEchartLabel === "bar09";
            if (isEdEchartScatter01) {
                type = "scatter01ItemColor";
            } else if (isEdEchartBar09) {
                type = "bar09ItemColor";
            } else if (this.echartType === "sankey") {
                type = "sankeyItemColor";
            }
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type });
            });
        }
        setScatter01ItemColor(color) {
            const option = JSON.parse(this.echartOption);
            const series = option.series;
            series[0].data[this.colorIndex - 1].itemStyle = { color };
            this.$bus.$emit("setEditEchartData", { series });
        }
        setBar09ItemColor(color) {
            const option = JSON.parse(this.echartOption);
            const series = option.series;

            const iArrItem = series[1]?.data?.[this.colorIndex - 1];
            const iArrItemValue = iArrItem?.value ?? iArrItem;
            if (iArrItem && iArrItemValue !== "-") {
                series[1].data[this.colorIndex - 1] = {
                    value: iArrItemValue,
                    itemStyle: { color },
                };
            }

            const eArrItem = series[2]?.data?.[this.colorIndex - 1];
            const eArrItemValue = eArrItem?.value ?? eArrItem;
            if (eArrItem && eArrItemValue !== "-") {
                series[2].data[this.colorIndex - 1] = {
                    value: eArrItemValue,
                    itemStyle: { color },
                };
            }

            this.$bus.$emit("setEditEchartData", { series });
        }
        setSankeyItemColor(color) {
            const option = JSON.parse(this.echartOption);
            const series = option.series;
            const link = series[0]?.links?.[this.colorIndex];
            if (link) {
                link.lineStyle = {
                    color,
                };
            }
            this.$bus.$emit("setEditEchartData", { series });
        }

        /**event */
        moveCell() {
            // 键盘控制移动
            this.closeAreaBox();
            this.selectCell(this.XcurrentIndex, this.YcurrentIndex);
            this.XAreaCell = [this.XcurrentIndex];
            this.YAreaCell = [this.YcurrentIndex];
            this.XhightLight = [this.XcurrentIndex + 1 + this.widthOffset];
            this.YhightLight = [this.YcurrentIndex + 1 + this.heightOffset];
        }
        dragBox(e, type) {
            // 拖动小方块
            this.YScrollOffset = 0; // 清除滚动记录
            let dragBox = document.getElementById("dragBox");
            let container = document.getElementById("tbContainer");
            let parent = e.target.parentNode.getBoundingClientRect() as DOMRect;
            let baseleft = (container.getBoundingClientRect() as DOMRect).x;
            let basetop = (container.getBoundingClientRect() as DOMRect).y;
            let direction = 0;
            let insideFlag = false;
            let [xstart, xend, ystart, yend] = this.selectDataArea;
            let xindex = this.XcurrentIndex;
            let yindex = this.YcurrentIndex;
            let dragIndexX = type == 1 ? xindex : xstart;
            let dragIndexY = type == 1 ? yindex : ystart;
            let xArrLength = 0;
            let yArrLength = 0;
            let xArrOffset = 0;
            let yArrOffset = 0;
            let xtempset = new Set();
            let ytempset = new Set();
            let parentOffsetX = parent.width + parent.x,
                parentOffsetY = parent.height + parent.y,
                x = e.pageX,
                y = e.pageY,
                clickx = parentOffsetX - x, // 消除点击位置影响
                clicky = parentOffsetY - y; // 消除点击位置影响
            let cssLeft = parent.x - baseleft;
            let cssTop = parent.y - basetop;
            let cssWidth = parent.width;
            let cssHeight = parent.height;
            dragBox.style.cssText = `left:${cssLeft}px;top:${cssTop}px;width:${cssWidth}px;height:${cssHeight}px;display:block`;
            document.onmousemove = (ev) => {
                let srcollTop = cssTop + this.YScrollOffset * this.baseHeight;
                insideFlag = false;
                let movex = ev.pageX - x;
                let movey = ev.pageY - y;
                let xnum = type == 1 ? xindex : xindex - (xindex - xstart);
                let ynum = type == 1 ? yindex : yindex - (yindex - ystart);
                let xtemp = movex - clickx + parent.width;
                let ytemp = movey - clicky + parent.height - this.YScrollOffset * this.baseHeight;
                xtempset = new Set();
                ytempset = new Set();
                if (ytemp < 0) {
                    // 上拖
                    let count = 0;
                    direction = 0;
                    while (ytemp < 0) {
                        ytemp += this.baseHeight;
                        ytempset.add(ynum);
                        ynum--;
                        count++;
                    }
                    yArrOffset = type == 1 ? 1 : yend - ystart + 1; // 上拖自身数据高度
                    dragIndexY = ynum;
                    dragIndexX = type == 1 ? xindex : xstart;
                    dragBox.style.cssText = `left:${cssLeft}px;top:${srcollTop - this.baseHeight * count}px;width:${cssWidth}px;height:${
                        cssHeight + this.baseHeight * count
                    }px;display:block`;
                } else if (ytemp > parent.height) {
                    // 下拖
                    direction = 1;
                    let count = -Math.floor(parent.height / this.baseHeight);
                    while (ytemp > 0) {
                        ytemp -= this.baseHeight;
                        ytempset.add(ynum);
                        ynum++;
                        count++;
                    }
                    yArrOffset = 0;
                    dragIndexY = type == 1 ? yindex : ystart;
                    dragIndexX = type == 1 ? xindex : xstart;
                    dragBox.style.cssText = `left:${cssLeft}px;top:${srcollTop}px;width:${cssWidth}px;height:${
                        cssHeight + this.baseHeight * count
                    }px;display:block`;
                } else {
                    if (xtemp < 0) {
                        // 左拖
                        direction = 2;
                        let count = 0;
                        while (xtemp < 0) {
                            xtemp += this.renderCol[xnum];
                            if (xnum >= 1) count += this.renderCol[xnum - 1];
                            xtempset.add(xnum);
                            xnum--;
                        }
                        xArrOffset = type == 1 ? 1 : xend - xstart + 1; // 左拖自身数据宽度
                        dragIndexY = type == 1 ? yindex : ystart;
                        dragIndexX = xnum > 0 ? xnum : 0;
                        dragBox.style.cssText = `left:${cssLeft - count}px;top:${srcollTop}px;width:${
                            cssWidth + count
                        }px;height:${cssHeight}px;display:block`;
                    } else if (xtemp > parent.width) {
                        // 右拖
                        direction = 3;
                        let count = 0;
                        while (xtemp > 0) {
                            xtemp -= this.renderCol[xnum];
                            count += this.renderCol[xnum];
                            xtempset.add(xnum);
                            xnum++;
                        }
                        xArrOffset = 0;
                        dragIndexY = type == 1 ? yindex : ystart;
                        dragIndexX = type == 1 ? xindex : xstart;
                        dragBox.style.cssText = `left:${cssLeft}px;top:${srcollTop}px;width:${count}px;height:${cssHeight}px;display:block`;
                    } else {
                        // 元素内，复原
                        insideFlag = true;
                        dragBox.style.cssText = `left:${cssLeft}px;top:${srcollTop}px;width:${cssWidth}px;height:${cssHeight}px;display:block`;
                    }
                }
            };
            document.onmouseup = () => {
                dragIndexY = dragIndexY + this.YScrollOffset; // 增加滚动后偏移index

                document.onmousemove = null;
                document.onmouseup = null;
                dragBox.style.display = "none";
                let xSetArr = [...xtempset]
                    .map((v) => (v as number) - 1)
                    .filter((e) => {
                        return e >= 0;
                    }); // 过滤小于等于0的错误数据
                let ySetArr;
                if (!direction) {
                    ySetArr = [...ytempset]
                        .map((v) => (v as number) + this.YScrollOffset - 1)
                        .filter((e) => {
                            return e >= 0;
                        });
                } else {
                    ySetArr = [...ytempset]
                        .map((v) => (v as number) - 1)
                        .filter((e) => {
                            return e >= 0;
                        });
                }
                if (insideFlag) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                    dragBox.style.display = "none";
                    return;
                }
                xArrLength += xSetArr.length;
                yArrLength += ySetArr.length;
                xArrLength += xArrOffset;
                yArrLength += yArrOffset;

                let data = [];
                if (type == 1) {
                    // 单个数据
                    let arrdata = "";
                    if (this.basedata[yindex + this.heightOffset + this.YScrollOffset])
                        if (this.basedata[yindex + this.heightOffset + this.YScrollOffset][xindex + this.widthOffset])
                            arrdata = this.basedata[yindex + this.heightOffset + this.YScrollOffset][xindex + this.widthOffset];
                    data.push([arrdata]);
                } else {
                    // 一组数据
                    for (let i = ystart; i < yend + 1; i++) {
                        let temp = [];
                        for (let j = xstart; j < xend + 1; j++) {
                            let arrdata = "";
                            if (this.basedata[i + this.heightOffset + this.YScrollOffset])
                                if (this.basedata[i + this.heightOffset + this.YScrollOffset][j + this.widthOffset])
                                    arrdata = this.basedata[i + this.heightOffset + this.YScrollOffset][j + this.widthOffset];
                            temp.push(arrdata);
                        }
                        data.push(temp);
                        temp = null;
                    }
                }
                this.setDragPasteData(dragIndexX, dragIndexY, xArrLength, yArrLength, data, direction);
            };
        }
        dragCell(e) {
            // 拖拽单元格
            window["_view"].editBlur();
            this.outOfView = false;
            this.outOfViewShift = false;
            this.outOfViewDrag = false;
            this.topClickAll = false;
            this.leftClickAll = false;
            this.startDrag = true;
            this.startShift = true;
            this.selectDataArea = [];
            this.DragScroll = 0;
            this.XDragScroll = 0;
            if (this.inputFlag) {
                this.closeInputBox();
                //return
            }
            if (this.areaFlag) {
                this.closeAreaBox(); // 关闭区域框
                this.areaFlag = false;
            }
            let target = e.target;
            target = target.tagName == "P" ? target.parentNode : target;
            let container = document.getElementById("tbContainer");
            let baseleft = (container.getBoundingClientRect() as DOMRect).x;
            let basetop = (container.getBoundingClientRect() as DOMRect).y;
            let obj = this.getIndex(target);
            let tempX = this.XcurrentIndex; // 备份点击坐标
            let tempY = this.YcurrentIndex; // 备份点击坐标
            this.XcurrentIndex = obj.xindex;
            this.YcurrentIndex = obj.yindex;

            let xindex = this.XcurrentIndex;
            let yindex = this.YcurrentIndex;
            this.XhightLight = [xindex + 1 + this.widthOffset];
            this.YhightLight = [yindex + 1 + this.heightOffset];
            this.XAreaCell = [xindex];
            this.YAreaCell = [yindex];
            let x = e.pageX,
                y = e.pageY,
                clickx = x - baseleft - (this.renderLine[xindex] + 50), // 消除点击位置影响
                clicky = y - basetop - this.baseHeight * (yindex + 1); // 消除点击位置影响
            if (xindex == 0) {
                clickx = x - baseleft - 50;
            }
            this.YcurrentIndex = yindex;
            if (e.shiftKey) {
                // shift
                this.shiftSelect(xindex, yindex);
                this.XcurrentIndex = tempX;
                this.YcurrentIndex = tempY;
                return;
            }
            this.shiftScroll = 0;
            this.selectCell(xindex, yindex);
            document.onmousemove = (ev) => {
                let movex = ev.pageX - x;
                let movey = ev.pageY - y;
                let obj = {
                    xnum: xindex,
                    ynum: yindex,
                    startX: clickx,
                    endX: movex,
                    startY: clicky,
                    endY: movey,
                };
                this.calcHightlight(obj);
                this.handleAutoScroll(ev.pageX, ev.pageY, obj);
                this.showAreaBox();
            };
            document.onmouseup = () => {
                if (this.YcurrentIndex - this.DragScroll < 0) {
                    this.outOfViewDrag = true;
                }
                document.onmousemove = null;
                document.onmouseup = null;
                let inputbox = document.getElementById("inputBox");
                if (inputbox && inputbox.childElementCount) {
                    let input = <HTMLInputElement>inputbox.children[0];
                    let left = 48 + this.renderLine[xindex];
                    let top = (yindex + 1) * this.baseHeight;
                    let width = this.renderCol[xindex] + 2;
                    if (xindex == 0) {
                        left = 48;
                    }
                    inputbox.style.cssText = `left:${left}px;top:${top}px;width:${width}px;display:block;opacity:0;z-index:-1;`;
                    input.focus({ preventScroll: true });
                }
                this.cancelAnimation();
            };
        }
        calcHightlight({ xnum, ynum, startX, endX, startY, endY }) {
            let xtempset: Set<number> = new Set();
            let ytempset: Set<number> = new Set();
            let xtemp = endX;
            let ytemp = endY;
            const calcXOffset = () => {
                let data = 0;
                let xOffset = xnum;
                let offset = this.XDragScroll;
                while (offset != 0) {
                    if (offset > 0) {
                        xOffset++;
                        offset--;
                        data += this.baseCol[xOffset] || 80;
                    } else {
                        xOffset--;
                        offset++;
                        data -= this.baseCol[xOffset] || 80;
                    }
                }
                return data;
            };
            let xScrollOffset = calcXOffset();
            let yScrollOffset = this.DragScroll * this.baseHeight;
            if (endX + xScrollOffset > 0) {
                xtemp = startX + xtemp + xScrollOffset;
                while (xtemp > 0) {
                    xtemp -= this.baseCol[xnum];
                    xtempset.add(xnum - this.XDragScroll);
                    xnum++;
                }
            } else {
                xtemp = startX + xtemp - this.baseCol[xnum] + xScrollOffset;
                while (xtemp < 0) {
                    xtemp += this.baseCol[xnum - this.XDragScroll];
                    xtempset.add(xnum - this.XDragScroll);
                    xnum--;
                }
            }
            if (endY + yScrollOffset > 0) {
                ytemp += startY + yScrollOffset;
                while (ytemp > 0) {
                    ytemp -= this.baseHeight;
                    ytempset.add(ynum - this.DragScroll);
                    ynum++;
                }
            } else {
                ytemp = startY + ytemp - this.baseHeight + yScrollOffset;
                while (ytemp < 0) {
                    ytemp += this.baseHeight;
                    ytempset.add(ynum - this.DragScroll);
                    ynum--;
                }
            }
            let tempOffset = this.DragScroll > 0 ? this.DragScroll : 0;
            let xtempOffset = this.XDragScroll > 0 ? this.XDragScroll : 0;
            this.XhightLight = [...xtempset]
                .filter((e) => {
                    return e + xtempOffset >= 0;
                })
                .map((v) => v + 1 + this.widthOffset);
            this.XAreaCell = [...xtempset].filter((e) => {
                return e + xtempOffset >= 0;
            });
            this.YhightLight = [...ytempset]
                .filter((e) => {
                    return e + tempOffset >= 0;
                })
                .map((v) => v + 1 + this.heightOffset);
            this.YAreaCell = [...ytempset].filter((e) => {
                return e + tempOffset >= 0;
            });
        }

        handleAutoScroll(x, y, highlightObj) {
            let autoReuslt = this.calcOutRange(x, y);
            if (autoReuslt[0] != null) {
                this.startXScrollAnimation(autoReuslt[0], highlightObj);
            } else {
                this.xScrollType = "";
                clearInterval(this.xScrollKey);
            }

            if (autoReuslt[1] != null) {
                this.startYScrollAnimation(autoReuslt[1], highlightObj);
            } else {
                this.yScrollType = "";
                clearInterval(this.yScrollKey);
            }
        }
        calcOutRange(x, y) {
            let container = document.getElementById("tbContainer");
            let rect = container.getBoundingClientRect();
            let result = [];
            if (x < rect.left) {
                if (y < rect.left - 100) {
                    result[0] = "hardLeft";
                } else {
                    result[0] = "left";
                }
            } else if (x > rect.left + rect.width) {
                if (x > rect.left + rect.width + 100) {
                    result[0] = "hardRight";
                } else {
                    result[0] = "right";
                }
            } else {
                result[0] = null;
            }

            if (y < rect.top) {
                if (y < rect.top - 100) {
                    result[1] = "hardTop";
                } else {
                    result[1] = "top";
                }
            } else if (y > rect.top + rect.height) {
                if (y > rect.top + rect.height + 100) {
                    result[1] = "hardBottom";
                } else {
                    result[1] = "bottom";
                }
            } else {
                result[1] = null;
            }
            return result;
        }
        scrollX(isRight = false, highlightObj) {
            if ((isRight && this.widthOffset >= this.xEnd) || (!isRight && this.widthOffset <= 0)) {
                return;
            }
            if (isRight) {
                this.moveright();
            } else {
                this.moveleft();
            }
            let percent = this.widthOffset / this.xEnd;
            (this.$refs["xscroller"] as any).changeSliderSize(0, percent);
            this.calcHightlight(highlightObj);
            this.showAreaBox();
        }
        scrollY(isDown = false, highlightObj) {
            if ((isDown && this.heightOffset >= this.yEnd) || (!isDown && this.heightOffset <= 0)) {
                return;
            }
            if (isDown) {
                this.movedown();
            } else {
                this.moveup();
            }
            let percent = this.heightOffset / this.yEnd;
            (this.$refs["yscroller"] as any).changeSliderSize(1, percent);
            this.calcHightlight(highlightObj);
            this.showAreaBox();
        }
        yScrollKey = null;
        yScrollType = "";
        xScrollKey = null;
        xScrollType = "";
        cancelAnimation() {
            this.yScrollType = "";
            clearInterval(this.yScrollKey);
            this.xScrollType = "";
            clearInterval(this.xScrollKey);
        }
        startXScrollAnimation(type, highlightObj) {
            if (this.xScrollType == type) return;
            this.xScrollType = type;
            let time = ["hardLeft", "hardRight"].includes(type) ? 60 : 180;
            clearInterval(this.xScrollKey);
            this.xScrollKey = setInterval(() => {
                this.scrollX(["right", "hardRight"].includes(type), highlightObj);
            }, time);
        }
        startYScrollAnimation(type, highlightObj) {
            if (this.yScrollType == type) return;
            this.yScrollType = type;
            let time = ["hardTop", "hardBottom"].includes(type) ? 60 : 180;
            clearInterval(this.yScrollKey);
            this.yScrollKey = setInterval(() => {
                this.scrollY(["bottom", "hardBottom"].includes(type), highlightObj);
            }, time);
        }

        widthControl(e) {
            // 顶部x轴鼠标移动事件
            if (this.widthControlFlag) {
                return;
            }
            this.widthControlFlag = true;
            setTimeout(() => {
                this.setLinePosition(e);
                this.widthControlFlag = false;
            }, 100);
        }
        setLinePosition(e) {
            // 控制短线显示隐藏
            let target = e.target;
            let shortline = document.getElementById("WidthControlShortLine");
            let container = document.getElementById("tbContainer");
            let baseleft = (container.getBoundingClientRect() as DOMRect).x;
            let nowposition = e.clientX - baseleft - 50;
            for (let i = 0; i < this.renderLine.length - 1; i++) {
                if (nowposition > this.renderLine[i] && nowposition < this.renderLine[i + 1]) {
                    shortline.style.left = `${this.renderLine[i] + this.renderCol[i] + 50}px`;
                    this.colWidthIndex = i;
                }
            }
        }
        shortlineClick(e) {
            // 点击短线取消移动事件，拖动结束后改变宽度
            let tControl = document.getElementById("topControl");
            let longline = document.getElementById("WidthControlLongLine");
            let shortline = document.getElementById("WidthControlShortLine");
            tControl.onmousemove = null;

            let x = e.pageX;
            let shortlineLeft = this.getStyle(shortline, "left").replace(/px/, "") - 0;
            longline.style.display = "block";
            longline.style.left = shortlineLeft + "px";
            let endWidth = 0;

            document.onmousemove = (ev) => {
                let movex = ev.pageX - x;
                movex =
                    this.renderCol[this.colWidthIndex] + movex < 60
                        ? 60 - this.renderCol[this.colWidthIndex]
                        : this.renderCol[this.colWidthIndex] + movex > 200
                          ? 200 - this.renderCol[this.colWidthIndex]
                          : movex;
                let templeft = shortlineLeft + movex;
                shortline.style.left = `${templeft}px`;
                longline.style.left = `${templeft}px`;
                endWidth = templeft - shortlineLeft;
            };
            document.onmouseup = () => {
                longline.style.display = "none";
                tControl.onmousemove = (e) => this.widthControl(e);
                document.onmousemove = null;
                document.onmouseup = null;
                this.resetWidth(endWidth);
            };
        }
        resetWidth(changewidth) {
            // 重置数组中的宽度数值
            let current = document.getElementById("currentBox");
            let inputbox = document.getElementById("inputBox");
            if (!inputbox) return;
            let input = <HTMLInputElement>inputbox.children[0];
            let temp = this.renderCol[this.colWidthIndex];
            let arr = [];
            this.renderCol.splice(this.colWidthIndex, 1, temp + changewidth);
            this.baseCol.splice(this.colWidthIndex + this.widthOffset, 1, temp + changewidth);

            for (let i = 0; i < this.renderLine.length; i++) {
                if (i == 0) {
                    this.renderLine[i] = 0;
                } else {
                    this.renderLine[i] = this.renderCol[i - 1] + this.renderLine[i - 1];
                }
            }

            current.style.left = `${this.renderLine[this.XcurrentIndex] + 49}px`;
            current.style.width = `${this.renderCol[this.XcurrentIndex] + 1}px`;
            inputbox.style.left = `${this.renderLine[this.XcurrentIndex] + 49}px`;
            inputbox.style.width = `${this.renderCol[this.XcurrentIndex] + 1}px`;
            input.focus({ preventScroll: true });
            this.showAreaBox();
        }
        topClick(e) {
            this.$store.commit("toShow", {
                type: "editEChart",
                data: true,
            });

            this.outOfView = true;
            this.areaFlag = true;
            this.topClickAll = true;
            this.leftClickAll = false;
            let container = document.getElementById("tbContainer");
            let baseleft = (container.getBoundingClientRect() as DOMRect).x;
            let x = e.pageX - baseleft - 50;
            let num = 0;
            for (let i = 0; i < this.renderLine.length - 1; i++) {
                if (x > this.renderLine[i + 1]) {
                    num++;
                } else {
                    break;
                }
            }
            this.selectCell(num, 0);
            this.clearHight();
            this.YcurrentIndex = 0;
            this.XhightLight.splice(0, 1, num + 1 + this.widthOffset);
            this.XAreaCell.splice(0, 1, num);
            this.YAreaCell = new Array(this.yViewCount + this.yEnd).fill(1).map((v, index) => index);
            this.selectDataArea = [num, num, 0, this.basedata.length];
            this.showAreaBox();
        }
        leftClick(e) {
            this.$store.commit("toShow", {
                type: "editEChart",
                data: true,
            });
            this.outOfView = true;
            this.areaFlag = true;
            this.topClickAll = false;
            this.leftClickAll = true;
            let container = document.getElementById("tbContainer");
            let basetop = (container.getBoundingClientRect() as DOMRect).y;
            let y = e.pageY - basetop - this.baseHeight;
            if (y < 0) {
                return;
            } // 左上角空白处理
            let num = 0;
            for (let i = 0; i < this.yViewCount; i++) {
                if (y > i * this.baseHeight) {
                    num++;
                } else {
                    break;
                }
            }
            this.selectCell(0, num - 1);
            this.clearHight();
            this.YcurrentIndex = num - 1;
            this.YhightLight.splice(0, 1, num + this.heightOffset);
            this.YAreaCell.splice(0, 1, num - 1);
            this.XAreaCell = new Array(this.xViewCount + this.xEnd - 1).fill(1).map((v, index) => index);
            let selectlength = this.basedata[num - 1] == undefined ? this.basedata[0].length : this.basedata[num - 1].length;
            this.selectDataArea = [0, selectlength, num - 1, num - 1];
            this.showAreaBox();
        }
        selectAll() {
            this.$store.commit("toShow", {
                type: "editEChart",
                data: true,
            });
            this.outOfView = true;
            this.areaFlag = true;
            this.topClickAll = true;
            this.leftClickAll = true;

            let maxLen = 0;
            for (let i = 0; i < this.basedata.length; i++) {
                maxLen = maxLen > this.basedata[i].length ? maxLen : this.basedata[i].length;
            }

            this.XAreaCell = new Array(this.xViewCount + this.xEnd - 1).fill(1).map((v, index) => index);
            this.YAreaCell = new Array(this.yViewCount + this.yEnd - 1).fill(1).map((v, index) => index);
            this.selectDataArea = [0, maxLen, 0, this.basedata.length];
            this.showAreaBox();
        }
        showInputBox(e) {
            // 显示输入框
            let viewWidth = 0;
            for (let i = 0; i < this.XcurrentIndex; ++i) {
                viewWidth += this.renderCol[i];
            }
            if (viewWidth + this.renderCol[this.XcurrentIndex] >= 408) {
                // 点击对象在视野外 408为图表可用宽度
                return;
            }
            this.keyFlag = true;
            this.inputFlag = true;
            let xindex = this.XcurrentIndex;
            let yindex = this.YcurrentIndex;
            let inputbox = document.getElementById("inputBox");
            if (!inputbox) return;
            let input = <HTMLInputElement>inputbox.children[0];
            let left = 48 + this.renderLine[xindex];
            let top = (yindex + 1) * this.baseHeight;
            let width = this.renderCol[xindex] + 2;
            if (xindex == 0) {
                left = 48;
            }
            inputbox.style.cssText = `left:${left}px;top:${top}px;width:${width}px;display:block`;
            if (this.renderData[yindex] != undefined) {
                if (this.renderData[yindex][xindex] != undefined) {
                    input.value = this.renderData[yindex][xindex];
                }
            } else {
                input.value = "";
            }
            this.tempInputValue = input.value;
            input.focus({ preventScroll: true });
            input.select();
        }
        closeInputBox() {
            // 关闭输入框
            if (!this.inputFlag) return; // 防止多次触发
            this.keyFlag = false;
            this.inputFlag = false;
            let inputbox = document.getElementById("inputBox");
            if (!inputbox) return;
            let input = <HTMLInputElement>inputbox.children[0];
            if (this.tempInputValue == input.value) {
                // 新旧值相同，不做修改
                input.value = "";
                inputbox.style.display = "none";
                return;
            }
            let xindex = this.XcurrentIndex;
            let yindex = this.YcurrentIndex;
            if (this.renderData[yindex] != undefined) {
                if (this.renderData[yindex][xindex] != undefined) {
                    this.basedata[yindex + this.heightOffset].splice(xindex + this.widthOffset, 1, input.value);
                } else {
                    let xnum = xindex + this.widthOffset - this.basedata[yindex].length;
                    while (xnum > 0) {
                        this.basedata[yindex + this.heightOffset].push("");
                        xnum--;
                    }
                    this.basedata[yindex + this.heightOffset].splice(xindex + this.widthOffset, 1, input.value);
                }
            } else {
                let ynum = yindex + this.heightOffset;
                ynum = this.basedata.length ? ynum - this.basedata.length + 1 : ynum;
                while (ynum > 0) {
                    let arr = [];
                    this.renderData.push(arr);
                    this.basedata.push(arr);
                    ynum--;
                }
                for (let i = 0; i < xindex + this.widthOffset + 1; i++) {
                    if (i != xindex + this.widthOffset) {
                        this.basedata[yindex + this.heightOffset][i] = "";
                    } else {
                        this.basedata[yindex + this.heightOffset][i] = input.value;
                    }
                }
            }
            this.completionSpace();
            this.setRenderData();
            let num = xindex;
            if (xindex + this.widthOffset >= this.baseCol.length - 1) {
                // 点击位置 + 偏移量 + 视图宽度5 > 总数据量宽度(数据宽度 + 视图宽度5 + 延伸区域3)     编辑最后一列时，平移一列
                this.addColumn();
                this.xScroll(1);
                (this.$refs["xscroller"] as any).changeSliderSize(0, 1);
            }
            if (yindex + this.heightOffset + 1 >= this.yEnd + this.yViewCount) {
                // 编辑最后一行时，平移一行
                this.addRow();
                this.yScroll(1);
                (this.$refs["yscroller"] as any).changeSliderSize(1, 1);
            }

            input.value = "";
            inputbox.style.display = "none";

            this.uploadData();
        }
        addColumn() {
            this.xEnd++;
            this.baseCol.push(80);
            this.renderCol.push(80);
            if (!this.firstFlag) this.scrollBlockWidth = this.setScrollerSize(0, this.baseCol.length - 1 - this.xViewCount - this.xEnd);
        }
        addRow() {
            this.yEnd++;
            if (!this.firstFlag) this.scrollBlockHeight = this.setScrollerSize(1, this.yEnd);
        }
        insertColumn(index, after = true) {
            let maxNum = 0;
            this.basedata.forEach((item) => (maxNum = Math.max(maxNum, item.length - 1)));
            let tempIndex = -1;
            if (after) {
                ++index;
                if (index <= maxNum) {
                    tempIndex = index;
                }
            } else {
                if (index >= 0 && index <= maxNum) {
                    tempIndex = index;
                }
            }
            this.xEnd++;
            this.baseCol.splice(index, 0, 80);
            this.renderCol.splice(index, 0, 80);
            if (tempIndex != -1) {
                this.basedata.forEach((item) => {
                    item.splice(tempIndex, 0, "");
                });
                this.setRenderData();
                this.showAreaBox();
                this.uploadData();
            }
        }
        insertRow(index, after = true) {
            let maxNum = this.basedata.length - 1;
            let tempIndex = -1;
            if (after) {
                index++;
                if (index <= maxNum) {
                    tempIndex = index;
                }
            } else {
                if (index >= 0 && index <= maxNum) {
                    tempIndex = index;
                }
            }
            this.yEnd++;
            if (tempIndex != -1) {
                this.basedata.splice(tempIndex, 0, []);
                this.setRenderData();
                this.showAreaBox();
                this.uploadData();
            }
        }
        showAreaBox() {
            this.areaFlag = true;
            let areabox = document.getElementById("areaBox");
            if (!areabox) return;
            let left, top, width, height;
            let xstart = this.XAreaCell[0];
            let xend = this.XAreaCell[this.XAreaCell.length - 1];
            let ystart = this.YAreaCell[0];
            let yend = this.YAreaCell[this.YAreaCell.length - 1];

            if (xstart > xend) [xstart, xend] = [xend, xstart];
            if (ystart > yend) [ystart, yend] = [yend, ystart];

            this.selectDataArea = [xstart, xend, ystart, yend];

            let safeXStart = xstart < 0 ? 0 : xstart;
            let safeXEnd = xend > this.renderCol.length - 1 ? this.renderCol.length - 1 : xend;

            if (xstart <= 0) {
                left = 49;
            } else {
                left = this.renderLine[xstart] + 49;
            }
            width = this.renderLine[safeXEnd] + 1 - this.renderLine[safeXStart] + this.renderCol[safeXEnd];

            top = (ystart + 1) * this.baseHeight;
            height = (yend + 2) * this.baseHeight - top + 1;

            areabox.style.cssText = `left:${left}px;top:${top}px;width:${width}px;height:${height}px;display:block`;
        }
        closeAreaBox() {
            let areabox = document.getElementById("areaBox");
            areabox && (areabox.style.display = "none");
        }
        keyboardEvent(e) {
            if (!this.$store.state.ui.editEChart) {
                return;
            }
            let code = e.keyCode;
            let ctrlKey = EDView.osInfo.platform === "Mac" ? e.metaKey : e.ctrlKey;
            if (!this.keyFlag && !ctrlKey) {
                if ((code > 47 && code < 58) || (code > 64 && code < 91) || (code > 96 && code < 110) || code == 229) {
                    // 229为输入法
                    if (this.XcurrentIndex !== undefined && this.YcurrentIndex !== undefined) {
                        let viewWidth = 0;
                        for (let i = 0; i < this.XcurrentIndex; ++i) {
                            viewWidth += this.renderCol[i];
                        }
                        if (viewWidth + this.renderCol[this.XcurrentIndex] >= 408) {
                            // 点击对象在视野外 408为图表可用宽度
                            return;
                        }
                        this.showInputBox(1);
                        return;
                    }
                }
            }
            switch (code) {
                case 9: {
                    // tab
                    if (this.inputFlag) {
                        return;
                    }
                    this.XcurrentIndex++;
                    this.XcurrentIndex = this.XcurrentIndex > this.xViewCount - 2 ? this.xViewCount - 2 : this.XcurrentIndex;
                    this.moveCell();
                    break;
                }
                case 13: {
                    // 回车
                    if (this.inputFlag) {
                        (document.getElementById("inputBox")?.children[0] as HTMLInputElement).blur();
                    } else {
                        this.YcurrentIndex++;
                        this.YcurrentIndex = this.YcurrentIndex > this.yViewCount - 1 ? this.yViewCount - 1 : this.YcurrentIndex;
                        this.moveCell();
                    }
                    break;
                }
                case 37: {
                    // 左
                    if (this.inputFlag) {
                        return;
                    }
                    this.XcurrentIndex--;
                    this.XcurrentIndex = this.XcurrentIndex < 0 ? 0 : this.XcurrentIndex;
                    this.moveCell();
                    break;
                }
                case 38: {
                    // 上
                    if (this.inputFlag) {
                        this.closeInputBox();
                    }
                    this.YcurrentIndex--;
                    this.YcurrentIndex = this.YcurrentIndex < 0 ? 0 : this.YcurrentIndex;
                    this.moveCell();
                    break;
                }
                case 39: {
                    // 右
                    if (this.inputFlag) {
                        return;
                    }
                    this.XcurrentIndex++;
                    this.XcurrentIndex = this.XcurrentIndex > this.xViewCount - 2 ? this.xViewCount - 2 : this.XcurrentIndex;
                    this.moveCell();
                    break;
                }
                case 40: {
                    // 下
                    if (this.inputFlag) {
                        this.closeInputBox();
                    }
                    this.YcurrentIndex++;
                    this.YcurrentIndex = this.YcurrentIndex > this.yViewCount - 1 ? this.yViewCount - 1 : this.YcurrentIndex;
                    this.moveCell();
                    break;
                }
                case 8:
                // Backspace
                case 46: {
                    // delete
                    if (this.inputFlag) {
                        return;
                    }
                    if (this.areaFlag) this.deleteExcelData(1);
                    else this.deleteExcelData(0);
                    break;
                }

                case 65: {
                    // a
                    if (ctrlKey) {
                        if (this.inputFlag) {
                            return;
                        }
                        e.preventDefault();
                        this.selectAll();
                    }
                    break;
                }
                case 83: {
                    // s
                    // e.preventDefault();
                    break;
                }
                case 89: {
                    // y
                    if (ctrlKey) {
                        this.redo();
                    }
                    break;
                }
                case 90: {
                    // z
                    if (ctrlKey) {
                        this.undo();
                    }
                    break;
                }
            }
        }
        setRenderData() {
            // 重置渲染数据
            let arr1 = [],
                arr2 = [];
            for (let i = this.heightOffset; i < this.basedata.length; i++) {
                let data = [];
                for (let j = this.widthOffset; j < this.basedata[i].length; j++) {
                    data.push(this.basedata[i][j]);
                }
                arr1.push(data);
            }
            for (let i = this.widthOffset; i < this.widthOffset + 10; i++) {
                if (this.baseCol[i]) arr2.push(this.baseCol[i]);
            }

            for (let i = 0; i < this.renderLine.length; i++) {
                if (i == 0) {
                    this.renderLine[i] = 0;
                } else {
                    this.renderLine[i] = arr2[i - 1] + this.renderLine[i - 1];
                }
            }
            this.renderData = arr1;
            this.renderCol = arr2;
        }
        moveleft() {
            let current = document.getElementById("currentBox");
            let areabox = document.getElementById("areaBox");
            let inputbox = document.getElementById("inputBox");
            this.widthOffset--;

            inputbox.style.display = "none";

            this.xArr = this.xArr.map((v) => v - 1);
            this.XAreaCell = !this.leftClickAll ? this.XAreaCell.map((v) => v + 1) : this.XAreaCell;

            if (this.startDrag) {
                this.XDragScroll--;
            }
            this.setRenderData();
            this.XcurrentIndex++;
            if (this.XcurrentIndex >= 8) {
                current.style.display = "none";
                areabox.style.display = "none";
            } else if (this.XcurrentIndex >= 0) {
                current.style.display = "block";
                current.style.left = `${this.renderLine[this.XcurrentIndex] + 49}px`;
                if (this.areaFlag) this.showAreaBox();
            }
        }
        moveright() {
            let current = document.getElementById("currentBox");
            let areabox = document.getElementById("areaBox");
            let inputbox = document.getElementById("inputBox");
            this.widthOffset++;

            inputbox.style.display = "none";

            this.xArr = this.xArr.map((v) => v + 1);
            this.XAreaCell = !this.leftClickAll ? this.XAreaCell.map((v) => v - 1) : this.XAreaCell;

            if (this.startDrag) {
                this.XDragScroll++;
            }
            this.setRenderData();
            this.XcurrentIndex--;
            if (this.XcurrentIndex < 0) {
                current.style.display = "none";
                areabox.style.display = "none";
            } else if (this.XcurrentIndex < 8) {
                current.style.display = "block";
                current.style.left = `${this.renderLine[this.XcurrentIndex] + 49}px`;
                if (this.areaFlag) this.showAreaBox();
            }
        }
        moveup() {
            let current = document.getElementById("currentBox");
            let areabox = document.getElementById("areaBox");
            let inputbox = document.getElementById("inputBox");
            this.heightOffset--;
            if (this.heightOffset < 0) {
                this.heightOffset = 0;
                return;
            }
            if (this.startDrag) {
                this.DragScroll--;
            }
            if (this.startShift) {
                this.shiftScroll--;
            }
            inputbox.style.display = "none";

            this.yArr = this.yArr.map((v) => v - 1);
            this.YAreaCell = !this.topClickAll ? this.YAreaCell.map((v) => v + 1) : this.YAreaCell;

            this.setRenderData();
            this.YcurrentIndex++;
            if (this.YcurrentIndex >= this.yViewCount) {
                current.style.display = "none";
                areabox.style.display = "none";
            } else if (this.YcurrentIndex >= 0) {
                current.style.display = "block";
                current.style.top = `${(this.YcurrentIndex + 1) * this.baseHeight}px`;
                if (this.areaFlag) this.showAreaBox();
            }
        }
        movedown() {
            let current = document.getElementById("currentBox");
            let areabox = document.getElementById("areaBox");
            let inputbox = document.getElementById("inputBox");
            this.heightOffset++;
            if (this.heightOffset > this.yEnd + 1) {
                this.heightOffset = this.yEnd;
                return;
            }
            if (this.startDrag) {
                this.DragScroll++;
            }
            if (this.startShift) {
                this.shiftScroll++;
            }
            inputbox.style.display = "none";

            this.yArr = this.yArr.map((v) => v + 1);
            this.YAreaCell = !this.topClickAll ? this.YAreaCell.map((v) => v - 1) : this.YAreaCell;

            this.setRenderData();
            this.YcurrentIndex--;
            if (this.YcurrentIndex < 0) {
                current.style.display = "none";
                areabox.style.display = "none";
            } else if (this.YcurrentIndex < this.yViewCount) {
                current.style.display = "block";
                current.style.top = `${(this.YcurrentIndex + 1) * this.baseHeight}px`;
                if (this.areaFlag) this.showAreaBox();
            }
        }
        xScroll(e) {
            let num = Math.floor(this.xEnd * e);
            let start = this.widthOffset;
            if (num > start) {
                while (num > start) {
                    this.moveright();
                    start++;
                }
            } else {
                while (num < start) {
                    this.moveleft();
                    start--;
                }
            }
        }
        yScroll(e) {
            let num = Math.floor(this.yEnd * e);
            let start = this.heightOffset;
            if (num > start) {
                while (num > start) {
                    this.movedown();
                    start++;
                }
            } else {
                while (num < start) {
                    this.moveup();
                    start--;
                }
            }
        }
        tableWheel(e) {
            let dragBox = document.getElementById("dragBox");
            let top = parseInt(this.getStyle(dragBox, "top"));
            let bottom = parseInt(this.getStyle(dragBox, "bottom"));
            let direct = 1;
            if (-e.wheelDelta > 0) {
                // 下滚
                if (this.heightOffset >= this.yEnd) {
                    // 滚动至底部，屏蔽下滚事件
                    return;
                }
                this.movedown();
                let percent = this.heightOffset / this.yEnd;
                (this.$refs["yscroller"] as any).changeSliderSize(1, percent);
                direct = -1;
            } else {
                // 上滚
                if (this.heightOffset <= 0) {
                    // 滚动至顶部，屏蔽上滚事件
                    return;
                }
                this.moveup();
                let percent = this.heightOffset / this.yEnd;
                (this.$refs["yscroller"] as any).changeSliderSize(1, percent);
                direct = 1;
            }
            this.YScrollOffset += direct;
            dragBox.style.top = `${top + direct * this.baseHeight}px`;
            dragBox.style.bottom = `${bottom + direct * this.baseHeight}px`;
        }
        clearSelector() {
            // 取消选中框以及底色
            document.getElementById("currentBox").style.display = "none";
            this.closeAreaBox();
            this.closeInputBox();
            this.XhightLight = [];
            this.YhightLight = [];
            this.XAreaCell = [];
            this.YAreaCell = [];
        }
        importExcelClick() {
            this.clearSelector();
            document.getElementById("chartExcelInput").click();
        }
        importExcel(e) {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = (e) => {
                this.importExcelData = [];
                this.xEnd = 3;
                this.yEnd = 20;
                let res = window["_view"].chartImportFromExcel((e.target as any).result, this.importExcelData);
                if (res === eFlagExcelImport.MulPage) {
                    let msg = this.$t("ExcelTable.MulPage");
                    this.showMessage({
                        type: 2,
                        content: msg,
                    });
                }
                if (this.importExcelData.length * this.importExcelData[0].length > 1000) {
                    let msg = this.$t("ExcelTable.remindMsg") as string;
                    this.showMessage({
                        sponsor: "importExcel",
                        type: 0,
                        content: msg,
                    });
                } else {
                    // fix: p122_9597，导入大量数据时表格数据显示不全，修复之
                    if (this.importExcelData.length > 30) {
                        this.yEnd = this.importExcelData.length - 10;
                    }
                    if (this.importExcelData[0].length > 7) {
                        let tmpNum = this.importExcelData[0].length;
                        while (tmpNum > 7) {
                            this.addColumn();
                            tmpNum--;
                        }
                    }

                    // fix: p122_9597，兼容千位分隔符的数字
                    for (let i = 0; i < this.importExcelData.length; i++) {
                        for (let j = 0; j < this.importExcelData[i].length; j++) {
                            this.importExcelData[i][j] = fixThousandSeparatedNumber(this.importExcelData[i][j]);
                        }
                    }

                    this.basedata.splice(0, this.basedata.length, ...this.importExcelData);
                    this.setRenderData();
                    this.uploadData(true);
                }

                document.getElementById("chartExcelInput")["value"] = "";
            };
        }
        importExcelURL(url) {
            // let ts = this;
            // let file = e.target.files[0];
            // let reader = new FileReader();
            // reader.readAsBinaryString(file);
            // reader.onload = function (e) {
            //     ts.basedata = window['_view'].chartImportFromExcel(this.result);
            //     ts.setRenderData();
            //     ts.$store.commit('setEChart', 'chartData');
            // }
        }
        exportExcel() {
            this.sensors.track("echartEditData", {
                Catalogues: "chart",
                edit_value: "export",
            });
            window["_view"].chartExportToExcel(this.basedata);
        }
        exportCsv() {
            this.sensors.track("echartEditData", {
                Catalogues: "chart",
                edit_value: "export",
            });
            window["_view"].chartExportToExcel(this.basedata, "csv");
        }
        undo(flag = true) {
            if (this.inputFlag) return;
            flag && window["_view"].undo();
            // window['_view'].updateRightTable(window['_view']._activeShape.toTable());
        }
        redo() {
            if (this.inputFlag) return;
            window["_view"].redo();
            // window['_view'].updateRightTable(window['_view']._activeShape.toTable());
        }
        uploadData(importData = false) {
            // 提交数据到后台
            if (this.chartType === "table") {
                let regular = this.isIrregular();
                if (!regular) {
                    // 规则表
                    let a = this.getTotalRowLine();
                    window["_view"].setTableDate(a.row, a.line, this.basedata);
                } else {
                    // 不规则表
                    if (!this.checkOverflow()) {
                        let msg = this.$t("ExcelTable.tableWarn");
                        this.showMessage({
                            sponsor: "regularTable",
                            type: 0,
                            content: msg,
                        });
                    } else {
                        this.regularData();
                        window["_view"].setTableDate(-1, -1, this.regularMap);
                    }
                }
            } else {
                if (this.shapeType == "EChartItem") {
                    if (importData) {
                        this.sensors.track("echartEditData", {
                            Catalogues: "chart",
                            edit_value: "import",
                        });
                    } else {
                        this.sensors.track("echartEditData", {
                            Catalogues: "chart",
                            edit_value: "direct",
                        });
                    }
                    let list = JSON.parse(JSON.stringify(this.basedata));
                    list = list.filter((element) => {
                        let arr = element.filter((data) => {
                            return data != "";
                        });
                        return arr.length > 0;
                    });

                    // let result = chartData.changeDataset(list);

                    // 调整为更新最新chart数据
                    let tempChart = new ChartData();
                    tempChart.loadOption(this.echartOption, this.echartType);
                    tempChart.initDataSet();
                    let result = tempChart.changeDataset(list);
                    this.$bus.$emit("setEditEchartData", { ...result, force: true });
                } else {
                    window["_view"].processChartCMD("dataSheet", { data: this.basedata });
                    this.$store.commit("updateEChart", { isInit: false });
                }
            }
        }
        completionSpace() {
            // 补全空格
            if (this.isIrregular()) {
                // 不规则表不需要补全
                return;
            }
            let a = this.getTotalRowLine();
            for (let i = 0; i < a.row; i++) {
                for (let j = 0; j < a.line; j++) {
                    if (this.basedata[i][j] == undefined) {
                        this.basedata[i][j] = "";
                    }
                }
            }
        }
        copyEvent(event) {
            if (!this.$store.state.ui.editEChart) {
                // 焦点不在编辑echart数据时 屏蔽复制事件
                return;
            }

            let area = this.selectDataArea;
            let [xstart, xend, ystart, yend] = [...area];

            if (xstart > xend) [xstart, xend] = [xend, xstart];
            if (ystart > yend) [ystart, yend] = [yend, ystart];

            let arr = [];
            for (let i = 0; i < yend - ystart + 1; i++) {
                arr.push([]);
                for (let j = 0; j < xend - xstart + 1; j++) {
                    arr[i].push("");
                }
            }
            let xcount = 0,
                ycount = 0;

            let yFitStart = this.topClickAll ? ystart : ystart + this.heightOffset;
            let yFitEnd = this.topClickAll ? yend : yend + this.heightOffset;
            let xFitStart = this.leftClickAll ? xstart : xstart + this.widthOffset;
            let xFitEnd = this.leftClickAll ? xend : xend + this.widthOffset;
            for (let i = yFitStart; i < yFitEnd + 1; i++) {
                for (let j = xFitStart; j < xFitEnd + 1; j++) {
                    if (this.basedata[i] != undefined) {
                        if (this.basedata[i][j] != undefined) {
                            arr[ycount][xcount] = this.basedata[i][j];
                        } else {
                            arr[ycount][xcount] = "";
                        }
                    } else {
                        arr[ycount][xcount] = "";
                    }
                    xcount++;
                }
                xcount = 0;
                ycount++;
            }

            // 剪贴板操作
            let tempCopyData = arr.slice(0);
            let testdata = tempCopyData.reduce((a, b) => {
                return a.concat(b.join("\t"));
            }, []);
            let asdasd = testdata.join("\r\n");
            event.preventDefault();
            event.clipboardData.setData("text", asdasd);
        }
        pasteEvent(event) {
            if (!this.$store.state.ui.editEChart) {
                // 焦点不在编辑echart数据时 屏蔽粘贴事件
                return;
            }
            if (this.inputFlag) {
                return;
            }

            let text = event.clipboardData.getData("text");
            this.pasteExcel(text);
        }
        cutEvent(event) {
            if (!this.$store.state.ui.editEChart) {
                // 焦点不在编辑echart数据时 屏蔽复制事件
                return;
            }
            if (this.inputFlag) {
                return;
            }

            let xstart = this.XAreaCell[0];
            let xend = this.XAreaCell[this.XAreaCell.length - 1];
            let ystart = this.YAreaCell[0];
            let yend = this.YAreaCell[this.YAreaCell.length - 1];
            if (xstart > xend) [xstart, xend] = [xend, xstart];
            if (ystart > yend) [ystart, yend] = [yend, ystart];

            let arr = [];
            if (this.outOfViewDrag) {
                ystart += this.DragScroll - this.heightOffset;
                yend += this.DragScroll - this.heightOffset;
            }
            if (this.outOfViewShift) {
                ystart += this.shiftScroll - this.heightOffset;
                yend += this.shiftScroll - this.heightOffset;
            }
            for (let i = 0; i < yend - ystart + 1; i++) {
                arr.push([]);
                for (let j = 0; j < xend - xstart + 1; j++) {
                    arr[i].push("");
                }
            }
            let xcount = 0,
                ycount = 0;
            for (let i = ystart + this.heightOffset; i < yend + 1 + this.heightOffset; i++) {
                for (let j = xstart + this.widthOffset; j < xend + 1 + this.widthOffset; j++) {
                    if (this.basedata[i] != undefined) {
                        if (this.basedata[i][j] != undefined) {
                            arr[ycount][xcount] = this.basedata[i][j];
                            this.basedata[i].splice(j, 1, "");
                        } else {
                            arr[ycount][xcount] = "";
                        }
                    } else {
                        arr[ycount][xcount] = "";
                    }
                    xcount++;
                }
                xcount = 0;
                ycount++;
            }
            this.setRenderData();
            this.uploadData();

            // 剪贴板操作
            let tempCopyData = arr.slice(0);
            let testdata = tempCopyData.reduce((a, b) => {
                return a.concat(b.join("\t"));
            }, []);
            let asdasd = testdata.join("\r\n");
            event.preventDefault();
            event.clipboardData.setData("text", asdasd);
        }
        setDragPasteData(x, y, xArr, yArr, data, direction) {
            // 根据拖动行为设置粘贴数据
            let Arr = [];
            switch (direction) {
                case 0: {
                    // 上
                    let temp = [];
                    for (let i = 0; i < yArr / data.length; i++) {
                        temp = temp.concat(data);
                    }
                    temp.splice(yArr - data.length, temp.length);
                    Arr = temp.concat(data);
                    break;
                }
                case 1: {
                    // 下
                    let temp = [];
                    if (this.YcurrentIndex == this.YScrollOffset)
                        // 还原第一行为0被过滤的数据
                        yArr++;
                    for (let i = 0; i < yArr / data.length - 1; i++) {
                        temp = temp.concat(data);
                    }
                    temp.splice(yArr - data.length, temp.length);
                    Arr = data.concat(temp);
                    break;
                }
                case 2: {
                    // 左
                    let temp = data.slice(0);
                    for (let i = 0; i < xArr / data[0].length; i++) {
                        for (let j = 0; j < temp.length; j++) {
                            temp[j] = temp[j].concat(data[j]);
                        }
                    }
                    for (let i = 0; i < temp.length; i++) {
                        temp[i].splice(xArr - data[0].length, temp[i].length);
                    }
                    for (let j = 0; j < temp.length; j++) {
                        temp[j] = temp[j].concat(data[j]);
                    }
                    Arr = temp;
                    break;
                }
                case 3: {
                    // 右
                    let temp = data.slice(0);
                    if (this.XcurrentIndex == 0)
                        // 还原第一行为0被过滤的数据
                        xArr++;
                    for (let i = 0; i < xArr / data[0].length - 1; i++) {
                        for (let j = 0; j < temp.length; j++) {
                            temp[j] = temp[j].concat(data[j]);
                        }
                    }
                    for (let i = 0; i < temp.length; i++) {
                        temp[i].splice(xArr - data[0].length, temp[i].length);
                    }
                    for (let j = 0; j < temp.length; j++) {
                        temp[j] = data[j].concat(temp[j]);
                    }
                    Arr = temp;
                    break;
                }
            }
            this.dragPasteExcel(x, y, Arr);
        }
        dragPasteExcel(x, y, data) {
            // 拖动粘贴
            let pastestr = data;
            let arr = data;
            let addlineFlag = true;
            let offset = this.heightOffset;
            for (let i = 0; i < arr.length; i++) {
                var num = 0;
                for (let j = 0; j < arr[i].length; j++) {
                    let data = arr[i][j];
                    if (this.basedata[y + i + offset] != undefined) {
                        if (this.basedata[y + i + offset][j + x + this.widthOffset] != undefined) {
                            this.basedata[y + i + offset].splice(j + x + this.widthOffset, 1, data);
                        } else {
                            let xnum = x + this.widthOffset - this.basedata[y + i + offset].length;
                            while (xnum > 0) {
                                this.basedata[y + i + offset].push("");
                                xnum--;
                            }
                            this.basedata[y + i + offset].splice(j + x + this.widthOffset, 1, data);
                        }
                    } else {
                        let ynum = y + arr.length + offset;
                        ynum = this.basedata.length ? ynum - this.basedata.length : ynum;
                        while (ynum > 0 && addlineFlag) {
                            let arr = [];
                            this.basedata.push(arr);
                            ynum--;
                        }
                        addlineFlag = false;
                        for (let p = num; p < j + x + this.widthOffset + 1; p++) {
                            if (p != j + x + this.widthOffset) {
                                this.basedata[y + i + offset][p] = "";
                            } else {
                                this.basedata[y + i + offset][p] = data;
                            }
                            num++;
                        }
                    }
                }
            }
            this.completionSpace();
            this.setRenderData();
            this.uploadData();
        }
        pasteExcel(data) {
            // 粘贴
            let pastestr = data,
                pasteData = "";
            if (pastestr) {
                // 剪贴板有数据
                let len = pastestr.split("\n");
                if (len[len.length - 1] == "") {
                    // excel复制过来的数据，去除最后的空行
                    len.pop();
                }
                let asd = len.reduce((a, b) => {
                    let asd = b.replace(/[\r\n]/g, "").split(/\t/);
                    a.push(asd);
                    return a;
                }, []);
                pasteData = asd;
            } else {
                return;
            }

            if (pasteData.length == 0) {
                return;
            }
            let x = this.XcurrentIndex;
            let y = this.YcurrentIndex;
            let xOffset = this.widthOffset,
                yOffset = this.heightOffset;
            let arr = pasteData;
            let yAddNum = 0;
            if (arr[0].length - x - xOffset >= this.baseCol.length) {
                while (arr[0].length - x - xOffset >= this.baseCol.length) {
                    this.addColumn();
                }
                this.xScroll((x + arr[0].length - 1 + xOffset + this.xViewCount) / this.baseCol.length);
                (this.$refs["xscroller"] as any).changeSliderSize(0, (x + arr[0].length - 1 + xOffset + this.xViewCount) / this.baseCol.length);
            }
            if (y + yOffset + arr.length >= this.yEnd + this.yViewCount) {
                // 点击位置 + 复制数组的高度 + 纵向偏移量  > 总数据上限 20 + 视图高度18  +1(y从0开始需+1)和-1(数组点击位置开始粘贴)相抵消，不做加减
                let tempYEnd = this.yEnd;
                while (y + yOffset + arr.length - yAddNum >= tempYEnd + this.yViewCount) {
                    this.addRow();
                    yAddNum++; // 记录增加了几次
                }
                // this.yScroll((yOffset + yAddNum) / this.yEnd);
                // (this.$refs['yscroller'] as any).changeSliderSize(1, (yOffset + yAddNum) / this.yEnd);
            }

            let addlineFlag = true;
            for (let i = 0; i < arr.length; i++) {
                var num = 0;
                for (let j = 0; j < arr[i].length; j++) {
                    let data = fixThousandSeparatedNumber(arr[i][j]);
                    if (this.renderData[y + i] != undefined) {
                        if (this.renderData[y + i][j + x] != undefined) {
                            (data || !isNaN(data)) && this.basedata[y + i + yOffset].splice(j + x + xOffset, 1, data);
                        } else {
                            let xnum = x + xOffset - this.basedata[y + i].length;
                            while (xnum > 0) {
                                this.basedata[y + i + yOffset].push("");
                                xnum--;
                            }
                            this.basedata[y + i + yOffset].splice(j + x + xOffset, 1, data);
                        }
                    } else {
                        let ynum = y + arr.length + yOffset;
                        ynum = this.basedata.length ? ynum - this.basedata.length : ynum;
                        while (ynum > 0 && addlineFlag) {
                            let arr = [];
                            this.basedata.push(arr);
                            ynum--;
                        }
                        addlineFlag = false;
                        for (let p = num; p < j + x + xOffset + 1; p++) {
                            if (p != j + x + xOffset) {
                                this.basedata[y + i + yOffset][p] = "";
                            } else {
                                this.basedata[y + i + yOffset][p] = data;
                            }
                            num++;
                        }
                    }
                }
            }
            this.completionSpace();
            this.setRenderData();

            this.uploadData();
        }
        deleteExcelData(type) {
            // 删除数据
            if (type == 0) {
                // 删除一个
                let xindex = this.XcurrentIndex,
                    yindex = this.YcurrentIndex;
                this.basedata[yindex + this.heightOffset].splice(xindex + this.widthOffset, 1, "");
            } else if (type == 1) {
                // 删除区域
                let xstart, xend, ystart, yend;
                let area = this.selectDataArea;
                [xstart, xend, ystart, yend] = [...area];
                let xcount = 0,
                    ycount = 0;
                let yFitStart = this.topClickAll ? ystart : ystart + this.heightOffset;
                let yFitEnd = this.topClickAll ? yend : yend + this.heightOffset;
                let xFitStart = this.leftClickAll ? xstart : xstart + this.widthOffset;
                let xFitEnd = this.leftClickAll ? xend : xend + this.widthOffset;
                for (let i = yFitStart; i < yFitEnd + 1; i++) {
                    for (let j = xFitStart; j < xFitEnd + 1; j++) {
                        if (this.basedata[i] != undefined) {
                            if (this.basedata[i][j] != undefined) {
                                this.basedata[i].splice(j, 1, "");
                            }
                        }
                        xcount++;
                    }
                    xcount = 0;
                    ycount++;
                }
            }
            this.setRenderData();

            this.uploadData();
        }

        /**table 特殊处理 */
        isIrregular() {
            if (!window["_view"]._activeShape) {
                return false;
            }
            if (!window["_view"]._activeShape.toTable()) {
                return false;
            }
            return window["_view"]._activeShape.toTable().isIrregularTable();
        }
        cutOtherData() {
            // 删除多余数据
            this.basedata.splice(this.regularMap.length, this.basedata.length);
            for (let i = 0; i < this.regularMap.length; i++) {
                this.basedata[i].splice(this.regularMap[i].length, this.basedata[i].length);
            }
            this.setRenderData();
        }
        regularData() {
            // 根据初始data 设置数据
            for (let i = 0; i < this.regularMap.length; i++) {
                for (let j = 0; j < this.regularMap[i].length; j++) {
                    this.regularMap[i][j] = this.basedata[i][j];
                }
            }
        }
        checkOverflow() {
            // 检测是否与原始数据不同步  false不同步
            let checkflag = true;
            if (this.basedata.length > this.regularMap.length) checkflag = false;
            for (let i = 0; i < this.regularMap.length; i++) {
                if (!checkflag) break;
                for (let j = 0; j < this.basedata[i].length; j++) {
                    if (this.basedata[i][j] != "" && j >= this.regularMap[i].length) {
                        checkflag = false;
                        break;
                    }
                }
            }
            return checkflag;
        }
        changeToRegular() {
            let a = this.getTotalRowLine();
            for (let i = 0; i < a.row; i++) {
                for (let j = 0; j < a.line; j++) {
                    if (this.basedata[i][j] == undefined) {
                        this.basedata[i][j] = "";
                    }
                }
            }
            window["_view"].setTableDate(a.row, a.line, this.basedata);
        }
        removeEvent() {
            if (this.inputFlag) this.closeInputBox();
            this.clearHight();
            this.clearSelectCell();
            this.$store.commit("toShow", {
                type: "editEChart",
                data: false,
            });
            document.removeEventListener("copy", this.copyEL);
            document.removeEventListener("paste", this.pasteEL);
            document.removeEventListener("cut", this.cutEL);
            document.removeEventListener("keydown", this.keyboardEvent);
        }
        mouseLeave(e) {
            // 有可能会因为一些不明原因触发mouseLeave,增加一层判断是否为鼠标触发的
            if (e && e.relatedTarget) {
                // this.removeEvent();
            }
        }

        cleanEditStatus() {
            this.$store.commit("toShow", {
                type: "editEChart",
                data: false,
            });
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get changeColor() {
            return this.$store.state.echart.changeColor;
        }
        get isTable() {
            return this.$store.getters.isTable;
        }
        get chartColor() {
            return this.$store.state.echart.chartDataColor;
        }
        get isEChartData() {
            return this.$store.state.ui.isEChartData;
        }
        get shapeType() {
            return this.$store.state.shape.type;
        }
        @Watch("isEChartData")
        watchisEChartData(newVal: any) {
            if (newVal) {
                // 显示表格的时候更新baseHeight
                this.baseHeight = parseFloat((this.$refs.tbExcelBody as HTMLElement).children[0].getBoundingClientRect().height.toFixed(4));
            }
        }
        @Watch("chartColor")
        watchChartColor(newval: any, oldVal: any) {
            if (newval) {
                if (this.shapeType == "EChartItem") return;
                this.$nextTick(() => {
                    if (["bar", "radar", "line"].includes(this.$store.state.echart.currentType)) {
                        this.colorH = newval.map((v, k) => {
                            return this.hexify(v);
                        });
                        this.showColor = 1;
                    } else if (this.$store.state.echart.currentType == "pie") {
                        this.colorV = newval.map((v, k) => {
                            return this.hexify(v);
                        });
                        this.showColor = 2;
                    } else {
                        this.showColor = 0;
                    }
                    if (this.isTable) {
                        this.showColor = 0;
                    }
                    this.dataInit(this.chartData);
                });
            }
        }
        @Watch("changeColor")
        watchChangeColor(newval: any, oldVal: any) {
            if (newval !== "") {
                if (this.showColor == 1) {
                    this.colorH.splice(this.colorIndex, 1, newval);
                    this.$store.commit("setEChartState", { type: "chartDataColor", data: this.colorH });
                } else if (this.showColor == 2) {
                    this.colorV.splice(this.colorIndex, 1, newval);
                    this.$store.commit("setEChartState", { type: "chartDataColor", data: this.colorV });
                }
                if (this.colorIndex == this.$store.state.echart.index) {
                    let type = this.$store.state.echart.currentType;
                    switch (type) {
                        case "bar": {
                            this.$store.commit("setEChartState", {
                                type: "barColor",
                                data: newval,
                            });
                            break;
                        }
                        case "line": {
                            this.$store.commit("setEChartState", {
                                type: "lineColor",
                                data: newval,
                            });
                            break;
                        }
                        case "radar": {
                            this.$store.commit("setEChartState", {
                                type: "lineColor",
                                data: newval,
                            });
                            break;
                        }
                        case "pie": {
                            let pieList = this.$store.state.echart.pieList;
                            let temp = JSON.parse(JSON.stringify(pieList[this.colorIndex]));
                            temp.color = newval;
                            pieList.splice(this.colorIndex, 1, temp);
                            this.$store.commit("setEChartState", {
                                type: "pieList",
                                data: pieList,
                            });
                            break;
                        }
                    }
                }
                this.$store.commit("setEChartState", { type: "changeColor", data: "" });
            }
        }
        @Watch("chartData")
        onTypeChanged(newval: any, oldVal: any) {
            let flag = false;
            if (newval.length != oldVal.length) {
                flag = true;
            }
            for (let i = 0; i < newval.length; ++i) {
                if (flag || newval[i].length != oldVal[i].length) {
                    flag = true;
                    break;
                }
                let arr = newval[i];
                for (let j = 0; j < arr.length; ++j) {
                    if (newval[i][j] != oldVal[i][j]) {
                        flag = true;
                        break;
                    }
                }
            }
            // this.firstFlag = flag;
            if (newval && flag) {
                this.$nextTick(() => {
                    if (["bar", "radar", "line"].includes(this.$store.state.echart.currentType)) {
                        this.colorH = this.$store.state.echart.chartDataColor.map((v, k) => {
                            return this.hexify(v);
                        });
                        this.showColor = 1;
                    } else if (this.$store.state.echart.currentType == "pie") {
                        this.colorV = this.$store.state.echart.chartDataColor.map((v, k) => {
                            return this.hexify(v);
                        });
                        this.showColor = 2;
                    } else {
                        this.showColor = 0;
                    }
                    if (this.isTable) {
                        this.showColor = 0;
                    }
                    this.dataInit(this.chartData);
                });
            }
        }

        calcSeriesColor(series) {
            let list = [""];
            series.forEach((item) => {
                if (item?.itemStyle?.color) {
                    list.push(item.itemStyle.color);
                } else {
                    list.push("");
                }
            });
            return list;
        }
        get echartType() {
            return this.$store.state.newEchart.activeChartType;
        }
        get echartOption() {
            return this.$store.state.newEchart.activeChartOption;
        }
        echartHColorList = [];
        echartVColorList = [];
        initEchartColorList() {
            this.echartHColorList = [];
            this.echartVColorList = [];
            const option = JSON.parse(this.echartOption);
            switch (this.echartType) {
                case "bar": {
                    this.echartHColorList = this.calcSeriesColor(option.series);
                    break;
                }
                case "line": {
                    this.echartHColorList = this.calcSeriesColor(option.series);
                    break;
                }
                case "pie": {
                    if (option.edEchartLabel !== "pie06") {
                        this.echartVColorList = option.series[0].data
                            .filter((item) => !(item?.itemStyle?.color == "none"))
                            .map((item, index) => {
                                return item?.itemStyle?.color ?? option.color[index] ?? option.color[index % option.color.length];
                            });
                    }
                    break;
                }
                case "scatter": {
                    if (option.edEchartLabel === "scatter01") {
                        this.echartVColorList = option.series[0].data.map((item) => {
                            return item?.itemStyle?.color ?? option.series[0]?.itemStyle?.color;
                        });
                        this.echartVColorList.unshift("");
                    }
                    break;
                }
                case "radar": {
                    break;
                }
                case "sunburst": {
                    break;
                }
                case "sankey": {
                    // 返回16进制的颜色值经过 opacity = 0.2 （不透明度 * 0.2）的新颜色值
                    const fixColor = (color: string) => {
                        if (/^#[a-fA-F0-9]{6,8}$/.test(color)) {
                            if (color.length === 7) {
                                return color + Number(255 * 0.2).toString(16);
                            } else {
                                let endStr: number | string = parseInt(color.slice(-2), 16) * 0.2;
                                endStr = Math.round(endStr);
                                endStr = Number(endStr).toString(16);
                                if (endStr.length === 1) {
                                    endStr = "0" + endStr;
                                }
                                return color.slice(0, 7) + endStr;
                            }
                        }
                        return color;
                    };
                    this.echartVColorList = option.series[0].links.map((item) => {
                        const selfColor = item?.lineStyle?.color;
                        const inheritColor =
                            option.series[0]?.lineStyle?.color === "source"
                                ? option.series[0]?.data?.find((d) => d.name === item.source)?.itemStyle?.color
                                : option.series[0]?.lineStyle?.color;
                        return selfColor ?? fixColor(inheritColor);
                    });
                    break;
                }
                case "funnel": {
                    if (option.series.length > 1) {
                        let arr = [];
                        option.series.forEach((item) => {
                            arr = arr.concat(
                                item.data.map((item, index) => {
                                    return item?.itemStyle?.color ?? option.color[index] ?? option.color[index % option.color.length];
                                })
                            );
                        });
                        this.echartVColorList = arr;
                    } else {
                        this.echartVColorList = option.series[0].data.map((item, index) => {
                            return item?.itemStyle?.color ?? option.color[index] ?? option.color[index % option.color.length];
                        });
                    }
                    break;
                }
                case "waterfall": {
                    this.echartVColorList = option.series[1].data.map((item, index) => {
                        const itemValue = item.value ?? item;
                        if (itemValue !== "-") {
                            return item?.itemStyle?.color ?? option.series[1]?.itemStyle?.color ?? option.color[1];
                        }
                        return option.series[2]?.data?.[index]?.itemStyle?.color ?? option.series[2]?.itemStyle?.color ?? option.color[2];
                    });
                    this.echartVColorList.unshift("");
                    break;
                }
            }
        }
        reloadData() {
            this.initEchartColorList();
        }

        @Watch("echartOption", { immediate: true })
        watchEchartData(nv, ov) {
            if (nv != ov) {
                this.initEchartColorList();
            }
        }

        // 右键相关
        showContext = false;
        contextPos = { left: 0, top: 0 };
        menuType = 0;
        contextIndex = -1;
        handleContext(e, type) {
            let num = 0;
            if (type == 0) {
                let container = document.getElementById("tbContainer");
                let baseleft = (container.getBoundingClientRect() as DOMRect).x;
                let x = e.pageX - baseleft - 50;
                for (let i = 0; i < this.renderLine.length - 1; i++) {
                    if (x > this.renderLine[i + 1]) {
                        num++;
                    } else {
                        break;
                    }
                }
                num += this.widthOffset;
            } else {
                let container = document.getElementById("tbContainer");
                let basetop = (container.getBoundingClientRect() as DOMRect).y;
                let y = e.pageY - basetop - this.baseHeight;
                if (y < 0) {
                    return;
                }
                for (let i = 0; i < this.yViewCount; i++) {
                    if (y > i * this.baseHeight) {
                        num++;
                    } else {
                        break;
                    }
                }
                num--; // 消除第一格影响
                num += this.heightOffset;
            }
            this.contextIndex = num;
            this.menuType = type;
            this.contextPos.left = e.pageX;
            this.contextPos.top = e.pageY;
            this.showContext = true;
        }
        closeContext() {
            this.showContext = false;
        }
        handleContextEvent(data) {
            this.closeContext();
            let type = data[0];
            let position = data[1];
            if (type == "row") {
                this.insertRow(this.contextIndex, position == "After");
            } else {
                this.insertColumn(this.contextIndex, position == "After");
            }
        }

        mounted() {
            // 数据表 DPI下偏移,getBoundingClientRect获取不到display：none元素的值
            this.baseHeight =
                parseFloat((this.$refs.tbExcelBody as HTMLElement).children[0].getBoundingClientRect().height.toFixed(4)) > 0
                    ? parseFloat((this.$refs.tbExcelBody as HTMLElement).children[0].getBoundingClientRect().height.toFixed(4))
                    : this.baseHeight;
            if (["bar", "radar", "line"].includes(this.$store.state.echart.currentType)) {
                this.colorH = this.$store.state.echart.chartDataColor.map((v, k) => {
                    return this.hexify(v);
                });
                this.showColor = 1;
            } else if (this.$store.state.echart.currentType == "pie") {
                this.colorV = this.$store.state.echart.chartDataColor.map((v, k) => {
                    return this.hexify(v);
                });
                this.showColor = 2;
            } else {
                this.showColor = 0;
            }
            if (this.isTable) {
                this.showColor = 0;
            }
            this.eventInit();
            this.$nextTick(() => {
                this.dataInit(this.chartData);
            });
            this.$bus.$on("updateEchartData", this.reloadData);
            this.$bus.$on("setScatter01ItemColor", this.setScatter01ItemColor);
            this.$bus.$on("setBar09ItemColor", this.setBar09ItemColor);
            this.$bus.$on("setSankeyItemColor", this.setSankeyItemColor);
        }

        created() {
            this.copyEL = (e) => {
                this.copyEvent(e);
            };
            this.pasteEL = (e) => {
                this.pasteEvent(e);
            };
            this.cutEL = (e) => {
                this.cutEvent(e);
            };
            let ts: any = this;
            ts.$bus.$on("msgOperation", (data) => {
                if (data.sponsor == "importExcel" && data.data) {
                    this.basedata.splice(0, this.basedata.length, ...this.importExcelData);
                    this.uploadData(true);
                } else if (data.sponsor == "regularTable") {
                    (data.data && (this.changeToRegular(), true)) || this.cutOtherData();
                }
            });
        }

        beforeDestroy() {
            // 移除相关事件
            this.removeEvent();
            let ts: any = this;
            ts.$bus.$off("msgOperation");
            this.$bus.$off("updateEchartData", this.reloadData);
            this.$bus.$off("setScatter01ItemColor", this.setScatter01ItemColor);
            this.$bus.$off("setBar09ItemColor", this.setBar09ItemColor);
            this.$bus.$off("setSankeyItemColor", this.setSankeyItemColor);
        }
    }
</script>
<i18n>
{
  "zh": {
    "ExcelTable": {
      "tableWarn": "当前数据与原始数据冲突，是否转化为规则表",
      "remindMsg": "数据大于1000条，将会导致页面卡顿，是否导入",
      "MulPage": "检测到多页文档，正在导入第一页文档"
    }
  },
  "en": {
    "ExcelTable": {
      "tableWarn": "The current data is inconsistent with the original data， do you want to convert to a rule table?",
      "remindMsg": "The page will be stuck if the number of data is larger than 1000. Still importing?",
      "MulPage": "Detecting multi-page document，importing the first page of the document."
    }
  },
  "fr": {
    "ExcelTable": {
      "tableWarn": "Les données actuelles ne correspondent pas aux données d'origine ， voulez-vous les convertir en table de règles?",
      "remindMsg": "Données est supérieur à 1000, cela conduira à une page bloquée, qu'ils soient importés?",
      "MulPage": "Document multipage détecté, importer le document de première page\n"
    }
  },
  "de": {
    "ExcelTable": {
      "tableWarn": "Die aktuellen Daten stimmen nicht mit den Originaldaten überein. Möchten Sie in eine Regeltabelle konvertieren?",
      "remindMsg": "Die Seite bleibt hängen, wenn die Anzahl der Daten größer als 1000 ist. Importieren Sie noch?",
      "MulPage": "Erkennen eines mehrseitigen Dokuments, importiert die erste Seite des Dokuments."
    }
  },
  "jp": {
    "ExcelTable": {
      "tableWarn": "現在のデータは元のデータと衝突しています。規則テーブルに変換しますか？",
      "remindMsg": "データが1000個超えで、ページの処理速度に影響するため、インポートしてもよろしいですか？",
      "MulPage": "複数ページのドキュメントと識別してきます。最初のページをインポートしています。"
    }
  },
  "es": {
    "ExcelTable": {
      "tableWarn": "Los datos actuales son inconsistentes con el original data， ¿quieres convertirlo en una tabla de reglas?",
      "remindMsg": "La página se atascará si el número de datos es mayor de 1000. ¿Todavía importando?",
      "MulPage": "Detección de multipágina document，importing la primera página del documento"
    }
  },
  "pt": {
    "ExcelTable": {
      "tableWarn": "Os dados atuais são inconsistentes com os dados originais, deseja converter para uma tabela de regra?",
      "remindMsg": "A página irá parar se o número de dados for maior que 1000. Importar Ainda Assim?",
      "MulPage": "Detectanto documento com múltiplas páginas, importar a primeira página do documento."
    }
  },
  "it": {
    "ExcelTable": {
      "tableWarn": "I dati correnti non corrispondono a quelli originali. Desideri eseguire la conversione a una tabella di regole?",
      "remindMsg": "Nel caso in cui la quantità di dati fosse superiore a 1000, la pagina si bloccherà. Desideri procedere comunque con l'importazione?",
      "MulPage": "È stato rilevato un documento con più pagine. Verrà importata la prima pagina."
    }
  },
  "tw": {
    "ExcelTable": {
      "tableWarn": "當前數據與原始數據衝突，是否轉化為規則表",
      "remindMsg": "數據大於1000條，將會導致頁面卡頓，是否導入",
      "MulPage": "檢測到多頁檔案，正在導入第一頁檔案"
    }
  },
  "kr": {
    "ExcelTable": {
      "tableWarn": "현재 데이터가 원본 데이터와 일치하지 않습니다. 규칙 테이블로 변환하시겠습니까?",
      "remindMsg": "데이터가 1000건 이상이면 페이지가 다운됩니다.가져오시겠습니까?",
      "MulPage": "여러 페이지 문서가 감지되었습니다. 첫 페이지 문서 가져오는 중"
    }
  }
}
</i18n>
